const initGoBackButton = () => {
  const goBackButtonElement = document.getElementById('go-back-container');

  if (goBackButtonElement !== null) {
    goBackButtonElement.addEventListener('click', handleResourceButtonClick);
  }
};

const handleResourceButtonClick = (e) => {
  history.back();
};

export default initGoBackButton;
